<template>
  <g>
    <defs />
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <g transform="translate(4.7 3)">
      <path
        class="b"
        d="M11.62 8.44L5.3 14.67H3.55v-1.73L9.86 6.7z"
      />
      <path
        class="b"
        d="M10.64 1.42h2.76a1.41 1.41 0 011.49 1.32v14.52a1.41 1.41 0 01-1.49 1.32H1.49A1.41 1.41 0 010 17.26V2.74a1.41 1.41 0 011.49-1.32h2.77"
      />
      <rect
        class="b"
        width="6.43"
        height="2.85"
        rx="1"
        transform="translate(4.23)"
      />
    </g>
  </g>
</template>
<style scoped>
.b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px}
</style>